import { task } from 'mobx-task'
import { type ApprovedTransaction } from '@/features/payouts/admin/ApprovedTransaction'
import type { RemoveTransactionsFn } from './PayoutDraftingViewModel'

/**
 * View model for an approved transaction.
 */
export class ApprovedTransactionViewModel {
  constructor(
    public readonly transaction: ApprovedTransaction,
    private readonly _removeTransactions: RemoveTransactionsFn,
  ) {}

  /**
   * Removes the transaction from the payout.
   */
  remove = task.resolved(() => this._removeTransactions([this.transaction]))
}
